module.exports = __webpack_public_path__ + "static/media/plan-wom-400gb.40397a78.svg";